__turbopack_context__.v({
  "shop_icon": "ShopMenuItem-module-scss-module__Vy1q0G__shop_icon",
  "shop_link": "ShopMenuItem-module-scss-module__Vy1q0G__shop_link",
  "shop_menu": "ShopMenuItem-module-scss-module__Vy1q0G__shop_menu",
  "shop_menu_inner": "ShopMenuItem-module-scss-module__Vy1q0G__shop_menu_inner",
  "shop_menu_item": "ShopMenuItem-module-scss-module__Vy1q0G__shop_menu_item",
});
